export const InternalColumnId = {
  ExtraCol: 'extra-col',
} as const;

export const InternalColumnIds: string[] = Object.values(InternalColumnId);
